module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraBold.d52b2c87.ttf";